import { StepFunctionExecution, StepFunctionExecutionDetails } from 'features/admin/subpages/accountLinkingDashboard/AccountLinkingDashboardTypeDefs';

import { _request, APIBaseResponse, APIMethod } from '../';
import { buildQueryParams } from '../apiHelpers';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const STEP_FUNCTIONS_PATH_PREFIX = '/djlinkaccountexecutions';

export type APIStepFunctionExecutionDetailsGetParams = RequestParamsBase & {
    executionId: string,
    executionType: string
};

export type APIStepFunctionExecutionTaskSignalPostParams = RequestParamsBase & {
    signalType: string,
    executionType: string,
    userReason?: string,
    executionId: string
};

type APIStepFunctionRunningListGetResponse = APIBaseResponse<Array<StepFunctionExecution>>;
type APIStepFunctionExecutionDetailsGetResponse = APIBaseResponse<StepFunctionExecutionDetails>;

export const APIStepFunctionGetRunningList: APIMethod<RequestParamsBase|undefined, APIStepFunctionRunningListGetResponse> = (params?: RequestParamsBase) => (
    _request('GET', STEP_FUNCTIONS_PATH_PREFIX, undefined, params?.signal)
);

export const APIStepFunctionGetExecutionDetails: APIMethod<APIStepFunctionExecutionDetailsGetParams, APIStepFunctionExecutionDetailsGetResponse> =
    (params: APIStepFunctionExecutionDetailsGetParams) => {
        const queryParams = buildQueryParams({ executionType: params.executionType });
        return _request('GET', `${STEP_FUNCTIONS_PATH_PREFIX}/${encodeURIComponent(params.executionId)}?${queryParams}`, undefined, params.signal);
    };

export const APIStepFunctionExecutionTaskSignalPost: APIMethod<APIStepFunctionExecutionTaskSignalPostParams, APIBaseResponse> =
    (params: APIStepFunctionExecutionTaskSignalPostParams) => (
        _request('POST', `${STEP_FUNCTIONS_PATH_PREFIX}`, {
            signalType: params.signalType,
            executionType: params.executionType,
            userReason: params.userReason ?? null,
            executionId: params.executionId
        })
    );
